<template>
    <article>
        <section class="relative py-48 bg-white rounded-b-2xl">
            <div class="self-gutter">
                <div class="pb-48 self-content-sm">
                    <div>
                        <div class="flex flex-wrap flex-1 pb-48 -mx-12 -mt-48">
                            <CompanyData v-if="customerInfo.customertype === 'O'"/>
                            <PersonalData v-if="customerInfo.customertype === 'P'" />
                            <Address v-for="address in filteredAddresses" :key="address.address_type_name" :address="address"/>
                            <ContactInformation v-if="customerInfo.contacts"/>
                            <Subscriptions v-if="customerInfo.contacts"/>
                            <ContractualInformation v-if="customerInfo.customertype === 'O'"/>
                            <GroupHierarchy
                                v-if="customerInfo.customertype === 'O' && ((customerInfo.parent_companies && customerInfo.parent_companies.length) || (customerInfo.subsidiaries && customerInfo.subsidiaries.length))"/>
                        </div>
                    </div>
                    <!-- Travel Managers text -->
                    <div v-if="customerInfo.customertype === 'O'" class="pt-48">
                        <div class="self-body-text self-body-text--md">
                            <p>{{ $t('info.travel_managers_text') }}</p>
                        </div>
                    </div>
                    <div v-if="customerInfo.customertype === 'O'" class="pt-48">
                        <div class="overflow-hidden bg-blue-100 rounded-md">
                            <button class="flex justify-between w-full p-20 cursor-pointer" data-toggle='animatetoggle' ref="animateToggleButton"
                                    @click="animatetoggle('animateToggleButton')"
                                    aria-expanded="true" id="travel_managers">

                                <h3 class="mr-16 font-normal title-lg text-primary">
                                    {{ $t('info.travel_managers') }}</h3>

                                <span
                                    class="flex-shrink-0 w-32 transform rotate-90 h32 text-primary self-animatetoggle-icon">
                                    <IconArrowForwardSVG/>
                                </span>
                            </button>

                            <div class="overflow-hidden" aria-labelledby="travel_managers">
                                <div class="px-20 pt-10 pb-20">
                                    <div class="flex flex-wrap flex-1 -mx-12 -mt-48">
                                        <TravelManagerOrAuthPersonProfileCard v-for="person in customerInfo.travel_managers" :key="person.customer_id" :person="person" :is-travel-manager="true"/>
<!--                                        <AddTravelManager/>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Auth Person text -->
                    <div v-if="customerInfo.customertype === 'O'" class="pt-48">
                        <div class="self-body-text self-body-text--md">
                            <p>{{ $t('info.auth_person_text') }}</p>
                        </div>
                    </div>
                    <div v-if="customerInfo.customertype === 'O'" class="pt-48">
                        <div class="overflow-hidden bg-blue-100 rounded-md">
                            <button class="flex justify-between w-full p-20 cursor-pointer" data-toggle='animatetoggle' ref="animateToggleButton2"
                                    @click="animatetoggle('animateToggleButton2')"
                                    aria-expanded="false" id="volitatud_isikud">

                                <h3 class="mr-16 font-normal title-lg text-primary">
                                    {{ $t('info.authorised_persons') }}</h3>

                                <span
                                    class="flex-shrink-0 w-32 transform rotate-90 h32 text-primary self-animatetoggle-icon">
                                    <IconArrowForwardSVG/>
                                </span>
                            </button>

                            <div class="overflow-hidden max-h-0" aria-labelledby="volitatud_isikud">
                                <div class="px-20 pt-10 pb-20">
                                    <div class="flex flex-wrap flex-1 -mx-12 -mt-48">
                                        <TravelManagerOrAuthPersonProfileCard v-for="person in customerInfo.authorized_persons" :key="person.customer_id" :person="person" :is-travel-manager="false"/>
                                        <AddAuthorizedPerson v-if="customerInfo.role === 'travel_manager'"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- BonusCards text -->
                    <div v-if="customerInfo.customertype === 'P'" class="pt-48">
                        <div class="self-body-text self-body-text--md">
                            <p>{{ $t('info.bonuscard_text') }}</p>
                        </div>
                    </div>
                    <div v-if="customerInfo.customertype === 'P'" class="pt-48">
                        <div class="overflow-hidden bg-blue-100 rounded-md">
                            <button class="flex justify-between w-full p-20 cursor-pointer" data-toggle='animatetoggle' ref="animateToggleButton3"
                                    @click="animatetoggle('animateToggleButton3')" aria-expanded="false" id="boonuskaardid">

                                <h3 class="mr-16 font-normal title-lg text-primary">{{ $t('info.bonuscards') }}</h3>

                                <span
                                    class="flex-shrink-0 w-32 transform rotate-90 h32 text-primary self-animatetoggle-icon">
                                    <IconArrowForwardSVG/>
                                </span>
                            </button>

                            <div class="overflow-hidden max-h-0" aria-labelledby="boonuskaardid">
                                <div class="px-20 pt-10 pb-20">
                                    <div class="flex flex-wrap flex-1 -mx-12 -mt-48">
                                        <BonusCard v-for="card in customerInfo.bonus_cards" :key="card.bonus_card_id" :card="card"/>
                                        <AddBonusCard/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </article>
</template>

<script lang="ts">
import IconNotesSVG from '@/assets/static/icons-src/icon-notes.svg'
import IconArrowForwardSVG from '@/assets/static/icons-src/icon-arrow-forward.svg'
import IconPencilSVG from '@/assets/static/icons-src/icon-pencil.svg'
import { Component, Vue, Watch } from 'vue-property-decorator'
import AddTravelManager from '@/components/info-view-components/AddTravelManager.vue'
import AddAuthorizedPerson from '@/components/info-view-components/AddAuthorizedPerson.vue'
import CompanyData from '@/components/info-view-components/CompanyData.vue'
import ContactInformation from '@/components/info-view-components/ContactInformation.vue'
import ContractualInformation from '@/components/info-view-components/ContractualInformation.vue'
import initModal from '@/scripts/modal'
import UtilsMixin from '@/scripts/utils'
import { ICustomer } from '@/domain/ICustomer'
import PersonalData from '@/components/info-view-components/PersonalData.vue'
import BonusCard from '@/components/info-view-components/BonusCard.vue'
import AddBonusCard from '@/components/info-view-components/AddBonusCard.vue'
import Address from '@/components/info-view-components/Address.vue'
import { IAddresses } from '@/domain/IAddresses'
import GroupHierarchy from '@/components/info-view-components/GroupHierarchy.vue'
import TravelManagerOrAuthPersonProfileCard from '@/components/info-view-components/TravelManagerOrAuthPersonProfileCard.vue'
import Subscriptions from "@/components/info-view-components/Subscriptions.vue";
import store from "@/store";
@Component({
    components: {
        Subscriptions,
        TravelManagerOrAuthPersonProfileCard,
        GroupHierarchy,
        Address,
        AddBonusCard,
        PersonalData,
        ContractualInformation,
        ContactInformation,
        CompanyData,
        AddAuthorizedPerson,
        AddTravelManager,
        IconNotesSVG,
        IconArrowForwardSVG,
        IconPencilSVG,
        BonusCard
    },
    mixins: [UtilsMixin]
})
export default class BusinessInfoView extends Vue {
    async mounted() {
        await store.dispatch('getCountry');
        initModal()
    }

    get customerInfo(): ICustomer {
        return this.$store.getters.getCustomerInfo
    }

    // Computed property to filter addresses that are not "Postal"
    get filteredAddresses(): IAddresses[] {
        if (this.customerInfo.addresses === undefined) return []
        if (this.customerInfo.customertype === 'O') { // display addresses with type "Billing" or "Business" and billing or delivery allowed
            const addresses = this.customerInfo.addresses.filter(address => {
                return (address.address_type_name === 'Business' || address.address_type_name === 'Billing') && (address.billing_allowed || address.delivery_allowed)
            })
            return addresses === undefined ? [] : addresses
        } else if (this.customerInfo.customertype === 'P') {
            const address = this.customerInfo.addresses.filter(address => address.address_type_name === 'Postal')
            return address === undefined ? [] : address
        }
        return []
    }

    updated () : void {
        initModal() // Initialize new modals that appear when new customerid is selected by changging the role in the AccoundLogin.vue component
    }
}
</script>

<style scoped>
</style>
